export default __webpack_public_path__ + "static/media/transfer2.fc3cefdc.mp4";